export default "__VITE_ASSET__Cx9iQ85T__"